/**
 * The v3 SDK client for this app (ND-2357).
 *
 * Requests go through the app's axios instance so its interceptors (auth
 * cookie, retry, cache, 401 handling, schema version) apply exactly as they do
 * to v2 calls. The SDK itself knows nothing about the app: station ids, dates
 * in the workspace timezone and option names are resolved by the callers in
 * src/api/newsdesk.js before they reach it.
 *
 * Per-call cache policy rides in the SDK's opaque transport options:
 *   v3.stories.list(params, { transport: { cache: { maxAge: 30 * 1000, ignoreCache: true } } })
 */
import api from '@/config/api'
import { createNewsdeskClient, NewsdeskApiError } from '@scripps/newsdesk-sdk'

async function axiosTransport({ method, url, body, signal, options }) {
  try {
    const response = await api.request({ method, url, data: body, signal, cache: options?.cache })
    return response.data
  } catch (error) {
    if (error?.response) {
      throw new NewsdeskApiError({ status: error.response.status, body: error.response.data, url })
    }
    throw error
  }
}

export const v3 = createNewsdeskClient({ transport: axiosTransport })

export default v3
